import { createContext, useEffect, useState } from "react";
import HttpService from "../../hooks/Https-services";
import { getCurrentAuth } from "../../hooks/useAxiosPrivate";
import useCheckSubscibed from "../../hooks/useCheckSubscibed";
import PageRoutes, { APIRoutes } from "../../utils/constants";
import { useLocation } from "react-router-dom";
import React from "react";
const LoadingContext: any = createContext(null);

export const LoadingContextProvider = ({ children }: any) => {
  const [isLoadingPayment, setLoadingPaymet] = useState(false);
  const handleChange = (val: any) => {
    setLoadingPaymet(val);
  };
  const location = useLocation();
  const [logsCount, setLogsCount] = useState<any>([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const auth = getCurrentAuth();
  const GetLogs = async (signal: AbortSignal) => {
    try {
      const res = await HttpService.get(APIRoutes.GetLogsCount, signal);
      if (res) {
        setLogsCount(res.data.data.total_entries);
      }
    } catch (error) {}
  };
  const routes = [
    PageRoutes.UpcomingEvent.split("/")[1],
    PageRoutes.MyNAHLTV.split("/")[1],
    PageRoutes.Admin.split("/")[1],
    PageRoutes.HomePage.split("/")[1],
    PageRoutes.Packages.split("/")[1],
    PageRoutes.PersonalChannel.split("/")[1],
    PageRoutes.Alert.split("/")[1],
  ];
  useEffect(() => {
    const controller = new AbortController();
    if (auth?.AccessToken && routes.includes(location.pathname.split("/")[1])) {
      GetLogs(controller.signal);
    }
    return () => {
      controller.abort();
    };
  }, [auth?.AccessToken, isRefresh, location.pathname]);
  return (
    <LoadingContext.Provider
      value={
        {
          handleChange,
          isLoadingPayment,
          logsCount,
          setIsRefresh,
          isRefresh,
        } as any
      }
    >
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingContext;
